<template>
  <v-container class="fill-height">
    <v-row align="center" justify="center">
      <v-card max-width="600" class="pa-6 text-center">
        <v-icon size="80" color="error" class="mb-6" :icon="mdiAlertCircleOutline" />

        <v-card-title class="text-h4 mb-4">
          {{ title || $t('core.errors.system.title') }}
        </v-card-title>

        <v-card-text>
          <p class="text-body-1 mb-4">
            {{ message || $t('core.errors.system.message') }}
          </p>

          <v-chip v-if="errorCode" size="small" variant="tonal" color="error" class="mb-4">
            {{ $t('core.errors.system.code') }}: {{ errorCode }}
          </v-chip>

          <div v-if="showActions" class="mt-6">
            <v-btn
              v-if="showRetry"
              color="primary"
              variant="flat"
              size="large"
              @click="$emit('retry')"
              class="mb-2"
            >
              {{ $t('core.common.retry') }}
            </v-btn>

            <v-btn
              v-if="showHome"
              color="primary"
              variant="text"
              size="large"
              to="/"
              class="mb-2 ml-2"
            >
              {{ $t('core.common.home') }}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script setup lang="ts">
import { mdiAlertCircleOutline } from '@mdi/js'
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    title?: string
    message?: string
    errorCode?: string | number
    showRetry?: boolean
    showHome?: boolean
  }>(),
  {
    showRetry: true,
    showHome: false,
  },
)

defineEmits<{
  retry: []
}>()

const showActions = computed(() => props.showRetry || props.showHome)
</script>

<style scoped>
.v-container {
  min-height: 100vh;
}
</style>
